import React, { PropsWithChildren, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { styled } from '@mui/material/styles';
import { TooltipProps } from '@mui/material';
import ConditionalTooltip from './ConditionalTooltip';

const Text = styled('span')({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

type CroppedTextProps = {
  title: string;
  maxLength?: number;
  maxWidth?: number;
  TextComponent?: React.ElementType;
  tooltipProps?: TooltipProps;
} & PropsWithChildren;

export const CroppedText = ({
  TextComponent,
  tooltipProps,
  title = '',
  maxLength = 30,
  maxWidth = 300,
}: CroppedTextProps) => {
  const [isCropped, setIsCropped] = useState(false);

  const { ref } = useResizeDetector({
    handleWidth: true,
    refreshMode: 'debounce',
    refreshRate: 100,
    onResize: () => {
      if (ref.current) {
        const isTextTooWide = ref.current.scrollWidth > ref.current.clientWidth;
        setIsCropped(isTextTooWide);
      }
    },
  });

  const renderText = () => {
    if (TextComponent) {
      return (
        <TextComponent>
          <Text ref={ref} style={{ maxWidth: maxLength ? `${maxLength}ch` : maxWidth }}>
            {title}
          </Text>
        </TextComponent>
      );
    }

    return (
      <Text ref={ref} style={{ maxWidth: maxLength ? `${maxLength}ch` : maxWidth }}>
        {title}
      </Text>
    );
  };

  return (
    <ConditionalTooltip disableInteractive active={isCropped} title={title} {...tooltipProps}>
      {renderText()}
    </ConditionalTooltip>
  );
};
